import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui';

import "swiper/dist/css/swiper.css";
// import "path/to/swiper.min.js"
// import "path/to/swiper.animate.min.js"
import "./assets/css/public.css"
import "./assets/css/style.css"

Vue.use(ElementUI);

// 引入dayjs
import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs

// 全局id
Vue.prototype.webId = '365090f0-38a4-4fdf-8411-030a4306f752'
    // Vue.prototype.webId = '07B6E038-5E54-4D8B-96BA-00017DA274E4'
Vue.prototype.webIdGroup = 'BEE8AB69-65E3-4161-ACF7-0E09E4028BB8'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')